var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "panel panel-default" }, [
      _c(
        "div",
        {
          staticClass: "panel-heading",
          attrs: { role: "button", "aria-expanded": _vm.showPartnerDetails },
          on: { click: _vm.togglePartnerDetails }
        },
        [
          _c("strong", [_vm._v("Partner Connection Details")]),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa pull-right",
            class: _vm.showPartnerDetails ? "fa-caret-down" : "fa-caret-right"
          })
        ]
      ),
      _vm._v(" "),
      _vm.showPartnerDetails
        ? _c("div", { staticClass: "panel-body" }, [
            _c("p", { staticClass: "help-block" }, [
              _vm._v(
                "\n        When establishing an SFTP connection with a partner, share these connection details with them: "
              ),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("Hostname:")]),
              _vm._v(" "),
              _c("code", [_vm._v("sftp.goalbookapp.com")]),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("Port:")]),
              _vm._v(" "),
              _c("code", [_vm._v("22")]),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("Protocol:")]),
              _vm._v(" "),
              _c("code", [_vm._v("SFTP")]),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("Username:")]),
              _vm._v(" "),
              _c("code", [_vm._v(_vm._s(_vm.localUser.username))]),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("Home Directory:")]),
              _vm._v(" "),
              _c("code", [_vm._v(_vm._s(_vm.localUser.home_directory))])
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1)
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "tf-username" } }, [_vm._v("Username")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localUser.username,
            expression: "localUser.username"
          }
        ],
        staticClass: "form-control",
        class: {
          "is-invalid":
            !_vm.localUser.username.trim() && _vm.showValidationErrors
        },
        attrs: { id: "tf-username", type: "text" },
        domProps: { value: _vm.localUser.username },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.localUser, "username", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "tf-home-directory" } }, [
        _vm._v("Home Directory")
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localUser.home_directory,
            expression: "localUser.home_directory"
          }
        ],
        staticClass: "form-control",
        class: {
          "is-invalid":
            !_vm.localUser.home_directory.trim() && _vm.showValidationErrors
        },
        attrs: {
          id: "tf-home-directory",
          type: "text",
          placeholder: "/goalbook-sftp-dev/" + _vm.localUser.username
        },
        domProps: { value: _vm.localUser.home_directory },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.localUser, "home_directory", $event.target.value)
          }
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "help-block" }, [
        _vm._v("\n      Full S3 path starting with "),
        _c("code", [_vm._v("/")]),
        _vm._v(", for example "),
        _c("code", [
          _vm._v("/goalbook-sftp-dev/" + _vm._s(_vm.localUser.username))
        ]),
        _vm._v(".\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "tf-ssh-key" } }, [_vm._v("SSH Public Key")]),
      _vm._v(" "),
      !_vm.isEditingKey
        ? _c("div", { staticClass: "panel panel-default" }, [
            _c("div", { staticClass: "panel-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-10" }, [
                  _vm.localUser.ssh_public_key.trim()
                    ? _c("div", [
                        _c("pre", [
                          _vm._v(_vm._s(_vm.localUser.ssh_public_key))
                        ])
                      ])
                    : _c("span", { staticClass: "text-muted" }, [
                        _vm._v(
                          "\n              No SSH public key set\n            "
                        )
                      ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-2 text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-default",
                      attrs: { type: "button" },
                      on: { click: _vm.startEditingKey }
                    },
                    [
                      _c("i", { staticClass: "fa fa-edit" }),
                      _vm._v(" Edit\n            ")
                    ]
                  )
                ])
              ])
            ])
          ])
        : _c("div", { staticClass: "panel panel-default" }, [
            _c("div", { staticClass: "panel-body" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localUser.ssh_public_key,
                    expression: "localUser.ssh_public_key"
                  }
                ],
                ref: "sshKeyTextarea",
                staticClass: "form-control",
                attrs: { id: "tf-ssh-key", rows: "4" },
                domProps: { value: _vm.localUser.ssh_public_key },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.localUser,
                      "ssh_public_key",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "text-right margin-top-10" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.saveKeyEdit }
                  },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(" Save\n          ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-default margin-left-5",
                    attrs: { type: "button" },
                    on: { click: _vm.cancelKeyEdit }
                  },
                  [
                    _c("i", { staticClass: "fa fa-times" }),
                    _vm._v(" Cancel\n          ")
                  ]
                )
              ])
            ])
          ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "button" },
          on: { click: _vm.onSubmit }
        },
        [_vm._v("\n      " + _vm._s(_vm.submitLabel) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-default",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cancel")
            }
          }
        },
        [_vm._v("\n      Cancel\n    ")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "help-block" }, [
      _vm._v(
        "\n        The partner will need to create a public/private key pair. The public key should be added to the "
      ),
      _c("code", [_vm._v("ssh_public_key")]),
      _vm._v(
        " field above. The private key should be used to authenticate the SFTP connection. They key must be in one of the following "
      ),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://docs.aws.amazon.com/transfer/latest/userguide/key-management.html#ssh-authentication-algorithms"
          }
        },
        [_vm._v("formats")]
      ),
      _vm._v(":\n      ")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [_vm._v("rsa-sha2-256")]),
      _vm._v(" "),
      _c("li", [_vm._v("rsa-sha2-512")]),
      _vm._v(" "),
      _c("li", [_vm._v("ssh-rsa")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }